import { render } from "./inbox-check-card.vue?vue&type=template&id=80e99b6e"
import script from "./inbox-check-card.vue?vue&type=script&lang=js"
export * from "./inbox-check-card.vue?vue&type=script&lang=js"

import "./inbox-check-card.vue?vue&type=style&index=0&id=80e99b6e&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__